import { render, staticRenderFns } from "./TriggerBlockImagesBorder.vue?vue&type=template&id=0e354442&scoped=true&"
import script from "./TriggerBlockImagesBorder.vue?vue&type=script&lang=ts&"
export * from "./TriggerBlockImagesBorder.vue?vue&type=script&lang=ts&"
import style0 from "./TriggerBlockImagesBorder.vue?vue&type=style&index=0&id=0e354442&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../home/bearlogin/development/pinq-project/mono2/client/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e354442",
  null
  
)

export default component.exports